jQuery(document).ready(function ($) {
    $('img[title*="Nutrition"]').css('object-fit', 'contain')
})
